import 'bootstrap';
import '@popperjs/core';
import './custom/registration.js';
import './custom/swiper.js';
import './custom/contact-us.js';
import './custom/checkout.js';
import './custom/profile.js';
import './custom/products.js';
import './custom/actions.js';
import './custom/get-location.js';



import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();
